<section class="set-school-ids-page-container">
  <nav>
    <zbp-button-component
      (clickHandler)="goBack()"
      [iconName]="zbpIconNames.backArrow"
      theme="blackText"
      label="Back To Overview"
      [role]="'link'">
    </zbp-button-component>
  </nav>
  <header>
    <h3>Set School {{ hasMultipleSchools ? 'IDs' : 'ID' }}</h3>
    <ul>
      <li>You are required to choose a school ID before you can manage {{ isZbPortal ? 'classes and ' : '' }}accounts
        within a school.
      </li>
      @if (isZbPortal) {
        <li>Students will use their school ID in combination with their username/password to log in.
        </li>
      }
    </ul>
    <p>Input school {{ hasMultipleSchools ? 'IDs' : 'ID' }} and then select "SAVE" to proceed.</p>
    <ul>
      <li>{{ hasMultipleSchools ? 'Each' : 'Your' }} school ID must be unique within the {{ brandName }} system.</li>
      <li>Each school must have its own unique ID.</li>
      <li>If another institution has claimed the school ID you chose, you will be prompted to choose another one.</li>
      <li>School IDs must contain only lowercase alphabetic characters or numbers, and it must be
        between {{ schoolIdMinLength }} and {{ schoolIdMaxLength }}
        characters.
      </li>
    </ul>
  </header>
  <ng-container *ngTemplateOutlet="noSchools ? NoSchools : SchoolsForm">
  </ng-container>
  <ng-template #NoSchools>
    <div class="no-schools-error-box">
      There are no schools in this district. Please contact {{ brandName }} Technical Support for assistance in adding
      schools to your district.
    </div>
  </ng-template>
  <ng-template #SchoolsForm>
    <form [formGroup]="form" (submit)="onFormSubmit()">
      <div class="form-grid">
        <div class="spacer"></div>
        <h6>School {{ hasMultipleSchools ? 'IDs' : 'ID' }}</h6>
        @for (school of form.controls.schools.controls; track school; let i = $index) {
          <ng-container
            [formGroup]="school">
            <label id="schoolLabel_{{i}}"
              for="schoolInput_{{i}}"
              class="form-label">
              {{ school.controls.name.value }}
            </label>
            <div class="input-wrapper">
              <input id="schoolInput_{{i}}"
                formControlName="abbreviatedSchoolId"
                class="form-control"
                [class.is-invalid]="isInvalid(school.controls.abbreviatedSchoolId)"
                [attr.aria-invalid]="isInvalid(school.controls.abbreviatedSchoolId)"
                [attr.aria-describedby]="isInvalid(school.controls.abbreviatedSchoolId) ? ('school-error-' + i) : null"/>
              @if (isInvalid(school.controls.abbreviatedSchoolId)) {
                <div id="school-error-{{i}}"
                  class="invalid-feedback"
                  [innerHTML]="getErrorMessage(school.controls.abbreviatedSchoolId)()">
                </div>
              }
            </div>
          </ng-container>
        }
      </div>
      <div class="form-footer">
        <zbp-button-component
          type="submit"
          label="Save"
          [useMinWidth]="true">
        </zbp-button-component>
      </div>
    </form>
  </ng-template>
</section>
